exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".CategoriesList-local__categories--2h-Wv {\n  padding: 10rem 5.125rem;\n  background-color: #29394e; }\n\n.CategoriesList-local__list--3pxyo {\n  position: relative; }\n  .CategoriesList-local__list--3pxyo > li {\n    border-left: 1px solid #6d7f92;\n    padding-left: 5rem;\n    min-height: 10rem;\n    margin-bottom: 40px; }\n", ""]);

// exports
exports.locals = {
	"categories": "CategoriesList-local__categories--2h-Wv",
	"list": "CategoriesList-local__list--3pxyo"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"localIdentName":"[name]__[local]--[hash:base64:5]","importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["/home/runner/work/media/media/src","node_modules/foundation-sites/scss","node_modules/motion-ui/src"]}!./src/components/CategoriesList/CategoriesList.local.scss
// module id = 529
// module chunks = 0